var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWindows = function SvgIconWindows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 47,
    viewBox: "0 0 51 47"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.914 6.177v15.895h22.072V3.396zM25.533 3.153v18.92H51V0zM25.533 24.619v18.92L51 46.69V24.62zM.914 24.619v15.895l22.072 2.782V24.619z"
  }))));
};
export default SvgIconWindows;